import React from "react";
import { Skeleton } from "antd";

const LoadingParagraph: React.FC = () => <Skeleton active />;

export default LoadingParagraph;
